<template>
<b-overlay :show="show" rounded="sm">
  <b-card>
    <h3>Vincular Usuário</h3>
    <b-row>
      <b-col cols="6">
        <b-form-group label="Nome Completo: *">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="icon-user"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model.trim="usuario.nome" disabled/>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="CPF: *">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="icon-user"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-mask="'###.###.###-##'" v-model="usuario.cpf" disabled/>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form @submit.stop.prevent="vincular">
      <b-row>
        <b-col cols="6">
          <b-form-group label="Nome da Conferência: *">
            <b-form-select v-model="conferencia" :options="conferencias" required/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Perfil: *">
            <b-form-select v-model="perfil" :options="perfis" required/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2">
          <b-button block variant="primary" type="submit">
            <i class="fa fa-plus"></i>&nbsp;&nbsp;<span>Adicionar</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row>
      <b-col>
        <b-table id="conferencias" :fields="campos" :items="usuario.conferencias" :per-page="totalPorPagina" :current-page="paginaAtual" small bordered outlined>
          <template #cell(id)="data">
            <b-link title="Excluir" @click="remover(data.item.id)">
              <i class="fa fa-times" style="color: black"/>
            </b-link>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col><b-pagination v-model="paginaAtual" :total-rows="usuario.conferencias.length" :per-page="totalPorPagina" aria-controls="conferencias" v-show="usuario.conferencias.length > 0"/></b-col>
    </b-row>
    <b-row>
      <b-col>Exibindo página {{paginaAtual}} de {{Math.floor(usuario.conferencias.length / totalPorPagina) + (usuario.conferencias.length % totalPorPagina > 0 ? 1 : 0)}}, total de {{usuario.conferencias.length}} registro{{usuario.conferencias.length > 1 ? 's' : ''}}.</b-col>
    </b-row>
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row>
      <b-col sm="2">
        <b-button block @click="navigate('/usuarios')">
          <i class="fa fa-arrow-left"></i>&nbsp;&nbsp;Voltar
        </b-button>
      </b-col>
    </b-row>
  </b-card>
  </b-overlay>
</template>

<script>
import Vue from 'vue'

export default {
  data () {
    return {
      totalPorPagina: 10,
      paginaAtual: 1,
      usuario: {
        nome: null,
        cpf: null,
        conferencias: []
      },
      show: false,
      conferencia: null,
      conferencias: [],
      perfil: null,
      perfis: [],
      campos: [
        {key: 'conferencia_nome', label: 'Nome da Conferência', sortable: false},
        {key: 'perfil_nome', label: 'Perfil', sortable: false},
        {key: 'id', label: 'Ações', sortable: false, tdClass: 'centro', thClass: 'centro'}
      ]
    }
  },
  mounted () {
    this.carregarUsuario(this.$route.params.id)
    this.carregarConferencias()
    this.carregarPerfis()
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    carregarUsuario (id) {
      Vue.http.post('api/usuario/buscar', {id: id}).then(response => {
        let data = response.body.data

        if (data.length > 0) {
          this.usuario = {
            nome: data[0].nome,
            cpf: data[0].cpf,
            conferencias: data[0].conferencias
          }
        }
      })
    },
    carregarConferencias () {
      Vue.http.post('api/conferencia/buscar', {status: true}).then(response => {
        if (response.body.success) {
          let conferencias = response.body.data

          for (let i = 0; i < conferencias.length; i++) {
            this.conferencias.push({value: conferencias[i].id, text: conferencias[i].nome})
          }
        }
      })
    },
    carregarPerfis () {
      Vue.http.post('api/perfil/index', {status: true}).then(response => {
        if (response.body.success) {
          let perfis = response.body.data

          for (let i = 0; i < perfis.length; i++) {
            this.perfis.push({value: perfis[i].id, text: perfis[i].nome})
          }
        }
      })
    },
    sucesso (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    vincular () {
      let duplo = false
      let msg = false
      for (let i = 0; i < this.usuario.conferencias.length && !duplo; i++) {
        if(this.usuario.conferencias[i].conferencia_id === this.conferencia && this.usuario.conferencias[i].perfil_id === this.perfil){
            msg = 'O perfil e a conferência selecionados já foram vinculados para o usuário.';
            duplo = true
        }
        if(this.usuario.conferencias[i].conferencia_id === this.conferencia && this.usuario.conferencias[i].perfil_id !== this.perfil){
            msg = 'Já foi adicionado um perfil para esta conferência.';
            duplo = true
        }
      }

      if (duplo) {
        this.erro(msg)
      } else {
        this.$bvModal.msgBoxConfirm('Tem certeza que deseja vincular este usuário?', {
          noCloseOnBackdrop: true,
          centered: true,
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) {
            this.show = true
            Vue.http.put('api/usuario/vincular/' + this.$route.params.id + '/' + this.conferencia + '/' + this.perfil).then(response => {
              this.show = false
              if (response.body.success) {
                this.carregarUsuario(this.$route.params.id)
                this.sucesso('Usuário vinculado com sucesso!')
              }
            })
          }
        })
      }
    },
    remover (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja remover esse vínculo do Usuário? Ele perderá o acesso a conferência e as ações que o perfil permitiam a ele.', {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/usuario/desvincular/' + id).then(response => {
            if (response.body.success) {
              this.carregarUsuario(this.$route.params.id)
              this.sucesso('Vinculo removido com sucesso!')
            }
          })
        }
      })
    }
  }
}
</script>

<style>
  .centro {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/UsuarioVincular.vue